const timestampFields = {
  createdAt: "Erstellt am",
  updatedAt: "Geändert am",
};

const messages = {
  resources: {
    Account: {
      name: "Benutzer |||| Benutzer",
      fields: {
        emailAddress: "E-Mail",
        role: "Rolle",
        customerId: "Kunde",
        lastLogin: "Letzter Login",
        ...timestampFields,
      },
      roles: {
        SystemAdministrator: "System-Administrator",
        CustomerAdministrator: "Kunden-Administrator",
        WebmailService: "Webmail-Service",
      },
    },
    Customer: {
      name: "Kunde |||| Kunden",
      fields: {
        name: "Name",
        crmId: "CRM-Id",
        contactPerson: "Kontaktperson",
        domainCount: "Domains",
        ...timestampFields,
      },
    },
    Domain: {
      name: "Domain |||| Domains",
      fields: {
        domain: "Domain (ASCII)",
        unicodeName: "Domain (Unicode)",
        isMainDomain: "Ist Hauptdomain?",
        mainDomainId: "Hauptdomain",
        customerId: "Kunde",
        mailEnabled: "E-Mail aktiviert?",
        aliasDomainCount: "Alias-Domains",
        mailAccountCount: "E-Mail-Konten",
        mailForwardCount: "E-Mail-Weiterl.",
        username: "Benutzername",
        password: "Passwort",
        managedBy: "Verwaltet durch",
        serviceBookingId: "Service-Buchung",
        withoutServiceBooking: "Ohne Service-Buchung?",
        ...timestampFields,
      },
      domainManager: {
        NetworkteamAddix: "networkteam (Addix)",
        NetworkteamUnitedDomains: "networkteam (United Domains)",
        Customer: "Kunde",
      },
    },
    MailAccount: {
      name: "E-Mail Konto |||| E-Mail Konten",
      fields: {
        emailAddress: "E-Mail",
        username: "Benutzername",
        customerId: "Kunde",
        domainId: "Domain",
        ...timestampFields,
      },
    },
    MailForward: {
      name: "E-Mail Weiterleitung |||| E-Mail Weiterleitungen",
      fields: {
        fromEmailAddress: "Von E-Mail",
        toEmailAddress: "Ziel E-Mail(s)",
        description: "Beschreibung",
        customerId: "Kunde",
        domainId: "Domain",
        ...timestampFields,
      },
    },
    ServiceTemplate: {
      name: "Service-Vorlage |||| Service-Vorlagen",
      fields: {
        monthlyCost: "mtl. Preis",
        invoiceLineText: "Rechnungspositionstext",
        archived: "archiviert",
        resources: "Leistungen",
        serviceBookingsCount: "# Buchungen",
        ...timestampFields,
      },
    },
    ServiceBooking: {
      name: "Service-Buchung |||| Service-Buchungen",
      fields: {
        customerId: "Kunde",
        serviceTemplateId: "Service-Vorlage",
        amount: "Anzahl",
        comment: "Kommentar",
        bookedFrom: "Gebucht ab",
        canceledOn: "Gekündigt zum",
        invoicedUntil: "Abgerechnet bis",
        invoiceInterval: "Abrechnungsintervall",
        billingMethod: "Abrechnungsart",
        invoicedUntilLte: "Abgerechnet bis <=",
        invoicedUntilGt: "Abgerechnet bis >",
        domainIds: "Domains",
        discountPercent: "Rabatt (%)",
        additionalInvoiceLineText: "ergänzender Rechnungspositionstext",
        sepaBilling:{mandateReference: "Mandatsreferenz"},
        invoiceExportIds: "Rechnungs-Exporte",
        ...timestampFields,
      },
    },
    InvoiceExport: {
      name: "Rechnungs-Export |||| Rechnungs-Exporte",
      fields: {
        customerId: "Kunde",
        invoiceNumber: "Rechnungsnummer",
        serviceBookingIds: "Service-Buchungen",
        error: "Fehlermeldung",
        failed: "Angelegt mit Fehler",
        createdAt: "Datum",
        onlyErrors: "Nur Fehler",
        onlyFailed: "Nur angelegt mit Fehlern",
      }
    }
  },
  common: {
    search: "Suche",
    generatePassword: "Passwort generieren",
    passwordGeneratedAndCopied:
      "Passwort wurde generiert und in die Zwischenablage kopiert.",
    passwordNotCopied:
      "Passwort konnte nicht in die Zwischenablage kopiert werden.",
    generatePasswordWillCopyToClipboard:
      "Beim Generieren eines Passworts wird dieses in die Zwischenablage kopiert.",
  },
  error: {
    accessDenied: "Zugriff verweigert",
    invalidCredentials: "Ungültige Zugangsdaten",
    alreadyExists: "Ein Eintrag mit diesem Wert existiert bereits",
    mustBeAtLeast: "Muss mindestens %{0} sein",
  },
};
export default messages;
